import ThesisGeneratorPage from "./ThesisGeneratorPage";

export default ThesisGeneratorPage;
